/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingOutlined } from '@ant-design/icons';
import { Empty, Pagination } from 'antd';
import queryString from 'query-string';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import getAllUserSaloonsApi from '../../apis/user-saloons-apis/allUserSaloonsApi';
import ArchHeading from '../../common/arch-heading/ArchHeading';
import routerLinks from '../../components/app/routerLinks';
import UserContext from '../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../custom-hooks/useCustomApiRequest';
import checkRes from '../../utils/checkRes';
import SaloonStoreCard from '../single-saloon-page/SaloonStoreCard';
import './styles.scss';

const UserSaloonsPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);
  const [fetchedData, setFetchedData] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 0,
    total: 0
  });
  const { search } = useLocation();
  const customApiRequest = useCustomApiRequest();
  const values = queryString.parse(search);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    customApiRequest(
      getAllUserSaloonsApi({ ...values }, user?.token, i18n.language),
      (res) => {
        if (isMounted) {
          setIsLoading(false);
          if (checkRes(res) && res.data?.data?.data) {
            const data = res.data.data.data;
            setFetchedData(data);
            if (res.data.data?.pagination) {
              setPagination(res.data.data.pagination);
            }
          }
        }
      },
      (error) => {
        setIsLoading(false);
      }
    );

    return () => {
      isMounted = false;
    };
  }, [i18n.language, fetchCount, user, search]);

  const renderStores = () => {
    if (isLoading) {
      return (
        <div
          className="custom-container"
          style={{
            marginTop: 92,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <LoadingOutlined style={{ fontSize: 24 }} spin />
        </div>
      );
    } else if (fetchedData?.length === 0)
      return <Empty description={false}>No products Found!!!</Empty>;
    else if (fetchedData?.length > 0) {
      return (
        <>
          <div className="saloons-wrap">
            {fetchedData.map((obj) => (
              <SaloonStoreCard key={obj?.id} obj={obj} />
            ))}
          </div>

          {pagination?.total > 0 && (
            <Pagination
              locale={{
                jump_to: i18n?.language === 'ar' ? 'إذهب إلى' : 'Go to',
                // page: i18n?.language === 'ar' ? 'الصفحة' : 'Page'
                page: ''
              }}
              style={{
                marginTop: 22
              }}
              showSizeChanger={false}
              defaultCurrent={1}
              current={pagination.current_page}
              pageSize={pagination.per_page}
              total={pagination.total}
              // itemRender={itemRender}
              onChange={(page, pageSize) => {
                navigate(`${routerLinks.userSaloonsRoute}?page=${page}`);
              }}
              hideOnSinglePage={true}
            />
          )}
        </>
      );
    }
  };

  return (
    <div className="user-saloons-page">
      <div className="custom-container">
        <div className="page-content">
          <div className="title-wrap">
            <ArchHeading title={t('main_app_bar_links.user_saloons')} />
          </div>
          {renderStores()}
        </div>
      </div>
    </div>
  );
};

export default UserSaloonsPage;
